
    <app-header [title]='title' [subtitle]='subtitle'></app-header>
    <app-nav></app-nav>
    <ngx-loading-bar [includeSpinner]="false" [height]="'4px'" [color]="'#FFFFFF'"></ngx-loading-bar>
    <div class="container-main"><router-outlet></router-outlet></div>
    <app-footer></app-footer>
    <toaster-container [toasterconfig]="toasterconfig"></toaster-container>
  